"use client";

import { EthereumWalletConnectors } from "@dynamic-labs/ethereum";
import { DynamicContextProvider } from "@dynamic-labs/sdk-react-core";
import type { ReactNode } from "react";

interface DynamicProviderProps {
  children?: ReactNode;
}

export const DynamicProvider: React.FC<DynamicProviderProps> = ({
  children,
}) => {
  return (
    <DynamicContextProvider
      settings={{
        environmentId: process.env.NEXT_PUBLIC_DYNAMIC_ENVIRONMENT_ID ?? "",
        walletConnectors: [EthereumWalletConnectors],
        cssOverrides: `
        .login-view__scroll__section--separator, .login-with-email-form {
          display: none;
        }`,
      }}
    >
      {children}
    </DynamicContextProvider>
  );
};
